/** An obligatory service a buyer owes under a sale-and-service contract. */
export interface ServiceReminderEquipment {
  id: number;
  full_name: string;
  serial: string;
  warranty_until: string | null;
}

export type ServiceReminderStatusValue = "P" | "S" | "C" | "X";

export const SERVICE_REMINDER_PENDING: ServiceReminderStatusValue = "P";
export const SERVICE_REMINDER_SENT: ServiceReminderStatusValue = "S";
export const SERVICE_REMINDER_COMPLETED: ServiceReminderStatusValue = "C";
export const SERVICE_REMINDER_CANCELLED: ServiceReminderStatusValue = "X";

/** Chip colour per status, in the same palette as JOB_STATUS_COLOR_MAP:
 *  scheduled reads as info, sent-and-awaiting-the-visit as a warning, a
 *  service done as success, and a dropped one as neutral. */
export const SERVICE_REMINDER_STATUS_COLOR_MAP: Record<
  ServiceReminderStatusValue,
  "default" | "info" | "warning" | "success"
> = {
  P: "info",
  S: "warning",
  C: "success",
  X: "default",
};

export interface ServiceReminder {
  id: number;
  due_date: string;
  notify_at: string;
  status: ServiceReminderStatusValue;
  status_display: string;
  sent_at: string | null;
  completed_at: string | null;
  job: number | null;
  job_number: string | null;
  notes: string;
  is_overdue: boolean;
  client_id: number | null;
  client_name: string | null;
  contract_id: number | null;
  contract_number: string | null;
  equipments: ServiceReminderEquipment[];
  created_at: string;
  updated_at: string;
}

/** Counts behind the dashboard card. */
export interface ServiceReminderSummary {
  overdue: number;
  due_soon: number;
  total: number;
  window_days: number;
}
